import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-shell" }
const _hoisted_2 = { class: "count-label" }
const _hoisted_3 = {
  key: 0,
  class: "error-banner"
}
const _hoisted_4 = {
  key: 1,
  class: "loading-row"
}
const _hoisted_5 = { class: "association-card__top" }
const _hoisted_6 = {
  class: "association-card__icon",
  "aria-hidden": "true"
}
const _hoisted_7 = { class: "association-card__copy" }
const _hoisted_8 = { class: "association-card__title" }
const _hoisted_9 = { class: "association-card__meta-inline" }
const _hoisted_10 = { class: "association-card__meta-stack" }
const _hoisted_11 = { class: "association-card__meta-row" }
const _hoisted_12 = { class: "association-card__location" }
const _hoisted_13 = {
  key: 0,
  class: "association-card__distance"
}

import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import AppCard from "@/shared/components/ui/AppCard.vue";
import { fetchCompanies } from "@/modules/vendor/services/vendors.api";
import AppSearchField from "@/shared/components/ui/AppSearchField.vue";
import AppTab from "@/shared/components/ui/AppTab.vue";
import AppButtonFlat from "@/shared/components/ui/AppButtonFlat.vue";

type CompanyAddress = {
  city: string;
  state: string;
  distance: string;
};
type CompanyItem = {
  name: string;
  id: number;
  description: string;
  application_status?: string;
  application_id?: number | null;
  address: Partial<CompanyAddress> | null;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'CompanyApplyPage',
  setup(__props) {

const tabItems = [
  { label: "Listings", value: "not_applied" },
  { label: "Pending", value: "pending" },
  { label: "Approved", value: "approved" },
];
const router = useRouter();
const isLoading = ref(false);
const errorMessage = ref("");
const companies = ref<CompanyItem[]>([]);
const searchQuery = ref("");
const activeTab = ref(tabItems[0].value);

const filteredCompanies = computed(() => {
  const status = String(activeTab.value || "").trim();
  const byStatus = status
    ? companies.value.filter(
        (c) => String(c.application_status || "not_applied") === status
      )
    : companies.value;

  const q = searchQuery.value.trim().toLowerCase();
  if (!q) return byStatus;
  return byStatus.filter((c) => {
    const name = String(c.name || "").toLowerCase();
    const desc = String(c.description || "").toLowerCase();
    const city = String(c.address?.city || "").toLowerCase();
    const state = String(c.address?.state || "").toLowerCase();
    return name.includes(q) || desc.includes(q) || city.includes(q) || state.includes(q);
  });
});

function formatLocation(city?: string, state?: string) {
  const c = String(city || "").trim();
  const s = String(state || "").trim();
  if (c && s) return `${c}, ${s}`;
  return c || s || "—";
}

onMounted(() => {
  void loadCompanies();
});

async function loadCompanies() {
  isLoading.value = true;
  errorMessage.value = "";
  try {
    const response: any = await fetchCompanies();
    const list = Array.isArray(response)
      ? response
      : Array.isArray(response?.data)
      ? response.data
      : [];
    companies.value = (list || []) as CompanyItem[];
  } catch (error) {
    console.error(error);
    errorMessage.value = "Unable to load associations. Please try again.";
    companies.value = [];
  } finally {
    isLoading.value = false;
  }
}

function handleOpen(id: string) {
  router.push({ name: "vendor.company.detail", params: { id } });
}

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppSearchField, {
      modelValue: searchQuery.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
      placeholder: "Search name, zip, city..."
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, _toDisplayString(filteredCompanies.value.length) + " ASSOCIATIONS AVAILABLE", 1),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    _createVNode(AppTab, {
      modelValue: activeTab.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeTab).value = $event)),
      items: tabItems
    }, null, 8, ["modelValue"]),
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            size: "18",
            width: "2"
          }),
          _cache[2] || (_cache[2] = _createElementVNode("span", null, "Loading associations...", -1))
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCompanies.value, (company) => {
            return (_openBlock(), _createBlock(AppCard, {
              key: company.id,
              class: "association-card",
              role: "button",
              tabindex: "0",
              onClick: ($event: any) => (handleOpen(String(company.id)))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_v_icon, {
                      size: "22",
                      color: "#e4572e"
                    }, {
                      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                        _createTextVNode("mdi-bank-outline", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(company.name), 1),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_v_icon, {
                            size: "14",
                            color: "#64748b"
                          }, {
                            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                              _createTextVNode("mdi-map-marker-outline", -1)
                            ]))]),
                            _: 1
                          }),
                          _createElementVNode("span", _hoisted_12, _toDisplayString(company.address), 1)
                        ]),
                        (company.address?.distance)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(company.address.distance), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  (company.application_status !== 'not_applied')
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 0,
                        class: "association-card__chev",
                        size: "18",
                        color: "#94a3b8"
                      }, {
                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                          _createTextVNode(" mdi-chevron-right ", -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128)),
          (!filteredCompanies.value.length && !errorMessage.value)
            ? (_openBlock(), _createBlock(AppCard, {
                key: 0,
                class: "empty-card"
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode(" No associations available right now. ", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}
}

})